import React from 'react';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';

import { TypeTimeIcon } from '../../../../images/icons/WrapSvg';

import TextField from '@material-ui/core/TextField';
import Close from '@material-ui/icons/Close';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';

import Task from './Task';


class Index extends React.Component {
    state = {
        valor: undefined,
        comment: '',
        point: 0,
        correction: 0,
        message: undefined,
        intervalId: undefined,
        desactivado: false,
        disabledmodoTest: false
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.data = data;
            state.valor = data.valor ? data.valor : '';
            state.desactivado = data.desactivado;
            state.parentDeactivated = parentDeactivated;
            state.disabledmodoTest = data.modoTest && !!state.valor;
            state.conditions = undefined;
            return state;
        }
        return null;
    }

    handleDateChange = (name, date, conditions, range) => {
        const error = conditions && date
            ? true
            : false;
        this.props.setValue(name, date, '', false, {});
        this.setState({ valor: date ? date : '', error: error });
    }

    handleClick = (name) => {
        if (!this.props.data.disabled && document.getElementById(name)) {
            document.getElementById(name).focus();
        }
    }

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, valor: undefined });
    }


    handleFocus = () => {
        const { data, valor } = this.state;
        if(data.modoTest && valor) {
            this.setState({  disabledmodoTest:  true });
        }
    }

    component = (name, intl, disabled, style, conditions, range, disabledmodoTest) => {
        const { data, valor } = this.state;
        if (disabled) {
            return (
                <span className="barlow_regular_textwrap c_slate text_align_left">
                    {this.state.valor}
                </span>
            );
        } else {
            if (style === 'NORMAL' || !conditions) {
                return (
                    <div className="flex_full_row align_center">
                        <TextField
                            name={name}
                            id={name}
                            label={intl.formatMessage({ id: 'date_field_label' })}
                            type="time"
                            value={valor}
                            disabled={disabledmodoTest && !!valor}
                            onFocus={this.handleFocus} 
                            format={'HH:MM'}
                            placeholder='HH:MM'
                            onChange={(event) => this.handleDateChange(name, event.target.value)}
                            className={'flex_full_row'}
                            InputLabelProps={{ shrink: true }}
                        />
                        {!data.modoTest &&
                            <Close
                                className="c_lipstick hand"
                                onClick={(event) => this.handleDateChange(name, undefined)}
                            />
                        }
                    </div>
                );
            } else {
                return (
                    <div className="flex_full_row align_center">
                        <TextField
                            name={name}
                            id={name}
                            label={intl.formatMessage({ id: 'date_field_label' })}
                            type="time"
                            value={valor}
                            disabled={disabledmodoTest && !!valor}
                            onFocus={this.handleFocus} 
                            onChange={(event) =>
                                this.handleDateChange(name, event.target.value, conditions, range)
                            }
                            format={'HH:MM'}
                            placeholder='HH:MM'
                            error={this.state.error}
                            helperText={
                                this.state.error
                                    ? intl.formatMessage({ id: 'error_date_field_future' })
                                    : ''
                            }
                            className={'flex_full_row'}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ inputProps: conditions }}
                        />
                        {!data.modoTest &&
                          <Close
                                className="c_lipstick hand"
                                onClick={(event) => this.handleDateChange(name, undefined)}
                            />  
                        }
                        
                    </div>
                );
            }
        }
    };

    render() {
        const { valor, desactivado, parentDeactivated, conditions, disabledmodoTest } = this.state;
        const { data, last, intl, editable } = this.props;
        return (
            <Task
                key={data.codigo}
                data={data}
                value={valor && valor.length === 5 ? true : undefined}
                icon={<TypeTimeIcon color="primary" />}
                text="type_label_time"
                last={last}
                editable={editable}
                desactivado={desactivado || parentDeactivated}
                parentDeactivated={parentDeactivated}
                component={this.component(
                    data.codigo,
                    intl,
                    !editable || data.disabled || parentDeactivated || desactivado,
                    data.estilo,
                    conditions,
                    data.alertable,
                    disabledmodoTest
                )}
                onClick={() => this.handleClick(data.codigo)}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    null,
    mapDispatchToProps,
)(injectIntl(Index));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Time.js